export enum ImportStatus {
  Pending = 'Pending',
  Succeed = 'Succeed',
  Failed = 'Failed',
}
export type Import = {
  id: string;
  status: ImportStatus;
  outputLog?: string | null;
  hasOutputFile: boolean;
};
